<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/W7PfgY/tc-custom/9781399012959.jpg?1705189810399" alt="This image is the cover for the book Waffen-SS at Arnhem, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Waffen-SS at Arnhem, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <b>This pictorial WWII history examines the brutal Battle of Arnhem with particular focus on the SS units that fought the Allied push into the Netherlands.</b><br/><br/>The 1944 Arnhem airborne operation, immortalized by the film <i>A Bridge Too Far</i>, will forever be remembered as a great British feat of arms. British and Polish paratroopers displayed outstanding courage and tenacity in a desperate last stand situation. And yet, as this book describes, the plan was fatally flawed as the 9th and 10th SS Panzer Divisions were recuperating and concealed nearby. <br/><br/>What followed was a bloody battle of attrition the result of which was arguably inevitable. Drawing on rare and unpublished photographs, this volume in the Images of War series reveals the historical combat record of the Hohenstaufen and Frundsberg divisions. It describes the intensity of the fighting in and around Arnhem between these elite SS and supporting units against a lightly armed yet equally determined enemy. <br/><br/>In spite of the increasing certainty of German defeat, the SS soldier remained fanatically motivated. This superbly illustrated book with its well-researched text and full captions captures the drama of that historic battle for a bridge over the Rhine.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian Baxter
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d416e096